export default __webpack_public_path__ + "static/media/grafismo-background.8b81524a.png";